import React from 'react';
import BaseSectionWrapper from '../../siteBaseSections/baseSectionComponents/BaseSectionWrapper/BaseSectionWrapper';
import './PaymentJourneyMessage.scss';

export default function PaymentJourneyMessage({ header, body, footer }) {
  return (
    <BaseSectionWrapper
      section={{ type: 'payment_journey_message' }}
      backgroundColor="white"
    >
      <div className="c-payment-journey-message">
        <div className="container">
          {header && (
            <div className="row">
              <div className="col-xs-12">{header}</div>
            </div>
          )}
          {body && (
            <div className="row">
              <div className="col-xs-12">{body}</div>
            </div>
          )}
          {footer && (
            <div className="row">
              <div className="col-xs-12">{footer}</div>
            </div>
          )}
        </div>
      </div>
    </BaseSectionWrapper>
  );
}
